module.exports = __webpack_public_path__ + "img/32f223f.webp";